import React, { forwardRef, useImperativeHandle, useState } from 'react';
import Modal from '../utils/Modal/Modal';
import { CancelButton, ConfirmButton, Footer, Form, ModalContainer, TitleWrapper } from './SecretModal.styles';
import { Text24Bold } from '../../utils/Text/Text.styles';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Input from '../../utils/inputs/Input/Input';
import { notifyError } from '../../../utils/notify';
import { MANUAL_CHAT_SECRET } from '../../../utils/constants';

export const enterSecretFormSchema = yup.object({ secret: yup.string().required('Secret is required') }).required();

const SecretModal = forwardRef(({ onConfirm, loading }, ref) => {
  const [show, setShow] = useState(false);

  useImperativeHandle(ref, () => ({
    show() {
      setShow(true);
    },
    hide() {
      setShow(false);
    },
    toggle() {
      setShow(prev => !prev);
    },
  }));

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      secret: '',
    },
    delayError: 300,
    resolver: yupResolver(enterSecretFormSchema),
  });

  const onSubmit = data => {
    if (data.secret !== MANUAL_CHAT_SECRET) {
      notifyError('Wrong secret!');
      return;
    }
    onConfirm();
  };

  return (
    <Modal
      isOpen={show}
      onClose={() => setShow(false)}
      onAfterClose={() => {
        reset();
      }}
      shouldCloseOnOverlayClick={false}>
      <ModalContainer>
        <TitleWrapper>
          <Text24Bold>Enter Secret</Text24Bold>
        </TitleWrapper>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Input
            label="Secret"
            placeholder="Enter secret"
            {...register('secret')}
            error={errors.secret?.message}
            disabled={loading}
          />
          <Footer>
            <CancelButton type="button" title="Cancel" onClick={() => setShow(false)} />
            <ConfirmButton title="Confirm" isLoading={loading} />
          </Footer>
        </Form>
      </ModalContainer>
    </Modal>
  );
});

export default SecretModal;
